type Props = {
  dimension: number
}
export const TwitterIcon = ({ dimension }: Props) => {
  return (
    <svg
      className="inline py-1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 335 276"
      fill="#3ba9ee"
      width={dimension + 'px'}
      height={dimension + 'px'}
    >
      <path d="m302 70a195 195 0 0 1 -299 175 142 142 0 0 0 97 -30 70 70 0 0 1 -58 -47 70 70 0 0 0 31 -2 70 70 0 0 1 -57 -66 70 70 0 0 0 28 5 70 70 0 0 1 -18 -90 195 195 0 0 0 141 72 67 67 0 0 1 116 -62 117 117 0 0 0 43 -17 65 65 0 0 1 -31 38 117 117 0 0 0 39 -11 65 65 0 0 1 -32 35" />
    </svg>
  )
}
